'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"],
  _excluded2 = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import TableStyleControlButton from 'rich-text-lib/components/toolbar/TableStyleControlButton';
import TableCellStyleControlButton from 'rich-text-lib/components/toolbar/TableCellStyleControlButton';
import { CANVAS_TABLE_STYLES, CANVAS_TABLE_CELL_STYLES } from '../../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
export function addContextualTableStylesControls(editor) {
  const handleDimensionChange = (target, contextualNodeAttributes, {
    dimensions,
    dimensionType
  }) => {
    editor.fire('hsDimensionChange', {
      target,
      dimensions,
      dimensionType,
      contextualNodeAttributes
    });
  };
  const handleBorderWidthChange = (target, borderStyle, width) => {
    editor.fire('hsBorderWidthChange', {
      target,
      width,
      borderStyle
    });
  };
  const handleBorderStyleChange = (target, borderStyle) => {
    editor.fire('hsBorderStyleChange', {
      target,
      borderStyle
    });
  };
  const handleTableDimensionTypeChange = (target, tablePixelWidth, dimensionType) => {
    editor.fire('hsTableDimensionTypeChange', {
      target,
      dimensionType,
      tablePixelWidth
    });
  };
  const handleCellPaddingChange = (target, cellPadding) => {
    editor.fire('hsCellPaddingChange', {
      target,
      cellPadding
    });
  };
  const handleTableCaptionChange = (target, hasCaption) => {
    editor.fire('hsTableCaptionChange', {
      target,
      hasCaption
    });
  };
  const handleTableResponsiveChange = (target, isResponsive) => {
    editor.fire('hsTableResponsiveChange', {
      target,
      isResponsive
    });
  };
  const handleTableCustomStyleChange = (target, tableStyle) => {
    editor.fire('hsTableCustomStyleChange', {
      target,
      tableStyle
    });
  };
  tinymce.canvas.addButton(editor, CANVAS_TABLE_STYLES, {
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const {
        tableWidth,
        tablePixelWidth,
        tableCellPadding,
        tableBorderWidth,
        tableBorderStyle,
        tableCaption,
        tableIsResponsive,
        tableStyle,
        activeElement
      } = contextualNodeAttributes;
      return /*#__PURE__*/_jsx(TableStyleControlButton, Object.assign({}, rest, {
        dropdownClassName: "mce-hubspot-dropdown",
        tableWidth: tableWidth,
        cellPadding: tableCellPadding,
        borderWidth: tableBorderWidth,
        borderStyle: tableBorderStyle,
        tableCaption: tableCaption,
        tableIsResponsive: tableIsResponsive,
        tableStyle: tableStyle,
        onBorderWidthChange: handleBorderWidthChange.bind(null, activeElement, tableBorderStyle),
        onBorderStyleChange: handleBorderStyleChange.bind(null, activeElement),
        onTableDimensionTypeChange: handleTableDimensionTypeChange.bind(null, activeElement, tablePixelWidth),
        onCellPaddingChange: handleCellPaddingChange.bind(null, activeElement),
        onTableCaptionChange: handleTableCaptionChange.bind(null, activeElement),
        onTableResponsiveChange: handleTableResponsiveChange.bind(null, activeElement),
        onTableCustomStyleChange: handleTableCustomStyleChange.bind(null, activeElement)
      }));
    }
  });
  tinymce.canvas.addButton(editor, CANVAS_TABLE_CELL_STYLES, {
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded2);
      const {
        cellBorderWidth,
        cellBorderStyle,
        cellWidth,
        cellHeight,
        tableWidth,
        activeElement
      } = contextualNodeAttributes;
      const dimensions = {
        width: cellWidth,
        height: cellHeight
      };
      return /*#__PURE__*/_jsx(TableCellStyleControlButton, Object.assign({}, rest, {
        dropdownClassName: "mce-hubspot-dropdown",
        tableWidth: tableWidth,
        borderWidth: cellBorderWidth,
        borderStyle: cellBorderStyle,
        dimensions: dimensions,
        onBorderWidthChange: handleBorderWidthChange.bind(null, activeElement, cellBorderStyle),
        onBorderStyleChange: handleBorderStyleChange.bind(null, activeElement),
        onDimensionChange: handleDimensionChange.bind(null, activeElement, contextualNodeAttributes)
      }));
    }
  });
}